import { Box } from '@mui/material';
import { DataCellProps } from '../types';

export const DataDeletionTeamNameCell = ({ team }: DataCellProps) => {
  return <Box>{team.name}</Box>;
};
